<template>
    <div class="register-container">
        <div class="form-box">
            <div class="form-item need-border margin-bottom-20">
                <input
                    type="text"
                    maxlength="11"
                    class="phone-input"
                    placeholder="请输入手机号码"
                    v-model="registerInfo.userPhone"
                />
            </div>
            <div class="form-item">
                <div class="code-form need-border">
                    <input
                        type="text"
                        maxlength="6"
                        class="code-input"
                        placeholder="请输入验证码"
                        v-model="registerInfo.smsCode"
                    />
                </div>
                <div class="code-btn need-border" @click="getPhoneCode">
                    <span>{{ codeText }}</span>
                </div>
            </div>
            <div class="from-submit" @click="gotoSetPassword">
                <span>立即注册</span>
            </div>
        </div>
        <div class="explain-box">
            <img src="../../public/images/account/invite_explain.png" />
        </div>
    </div>
</template>
<script>
import { isPhone, isEmpty } from "@/utils/validation";
import Vue from "vue";
import utils from "@/utils/utils";
import { Toast } from "vant";
Vue.use(Toast);
const CODE_TEXT = "获取验证码";
//验证码类型
const CODE_TYPE_REGISTER = 0;
export default {
    data() {
        return {
            //注册信息
            registerInfo: {
                userPhone: "", //用户手机
                userPassword: "", //用户密码
                confirmPassword: "", //确认密码
                recommendCode: "", //推荐人
                smsCode: "", //手机验证码
            },
            isSendCode: false, //是否发送验证码中
            codeText: CODE_TEXT, //验证码文字
            isSumbitIng: false,
        };
    },
    beforeMount() {
        let { uid } = this.$route.query;
        if (uid) {
            this.registerInfo.recommendCode = uid;
        }
    },
    methods: {
        /**
         * @description 跳转页面
         */
        gotoView(path) {
            if (!path) return;
            this.$router.push({
                path: path,
            });
        },
        /**
         * @param {{object}} registerInfo 注册信息
         * @description 检测注册数据
         */
        validateRegisterInfo(registerInfo) {
            let { userPhone, smsCode } = registerInfo;
            if (!isPhone(userPhone)) {
                this.$toast("请输入正确的手机号码");
                return false;
            } else if (isEmpty(smsCode)) {
                this.$toast("请输入验证码");
                return false;
            }
            return true;
        },
        /**
         * @description 获取手机验证码
         */
        getPhoneCode() {
            let { userPhone } = this.registerInfo;
            let _this = this;
            if (this.isSendCode) return;
            if (!isPhone(userPhone)) {
                this.$toast("请输入正确的手机号码");
                return;
            }
            _this.hasUser(userPhone, (hasUser) => {
                if (hasUser) {
                    _this.$toast("此号码已经注册");
                    return;
                }
                _this.$axios
                    .post(_this.$api.commonApi.sendVerificationCode, {
                        userAccount: userPhone,
                        sendMsgType: CODE_TYPE_REGISTER,
                    })
                    .then((response) => {
                        _this.isSendCode = true;
                        utils.countDown(60, (second) => {
                            _this.codeText = `${second}s`;
                            if (second <= 0) {
                                _this.isSendCode = false;
                                _this.codeText = CODE_TEXT;
                            }
                        });
                    })
                    .catch(() => {
                        _this.isSendCode = false;
                    });
            });
        },
        /**
         * @description 跳转设置密码
         */
        gotoSetPassword() {
            if (!this.validateRegisterInfo(this.registerInfo)) return;
            this.$router.push({
                path: "/account/set/password",
                query: {
                    phone: this.registerInfo.userPhone,
                    smsCode: this.registerInfo.smsCode,
                    recommend: this.registerInfo.recommendCode,
                },
            });
        },
        /**
         * @description 是否注册此用户
         */
        hasUser(phone, cb) {
            if (!phone) {
                cb && cb(false);
            }
            let _this = this;
            this.$axios
                .post(_this.$api.accountApi.hasUser, {
                    userPhone: phone,
                })
                .then((response) => {
                    let isRegister = response.data || false;
                    cb(isRegister);
                })
                .catch(() => {});
        },
    },
};
</script>
<style lang="less" scoped>
.register-container {
    overflow: hidden;
    margin: 0 auto;
    padding-top: 515px;
    background-image: url("../../public/images/account/invite_register_bg.png");
    background-repeat: no-repeat;
    background-size: 750px auto;
    background-color: #81e1be;
    .form-box {
        margin: 0 auto;
        padding: 60px;
        width: 590px;
        background-color: #fff;
        border-radius: 20px;
        .need-border {
            overflow: hidden;
            border: 1px solid rgba(171, 184, 215, 1);
            border-radius: 12px;
        }
        > .form-item {
            width: 588px;
            height: 68px;
            > .code-form {
                float: left;
                width: 378px;
                height: 68px;
                > .code-input {
                    border: none;
                    padding-left: 30px;
                    width: 358px;
                    height: 68px;
                    font-size: 28px;
                    color: #282e3c;
                }
            }
            > .code-btn {
                float: right;
                width: 186px;
                height: 68px;
                font-size: 28px;
                line-height: 68px;
                color: #282e3c;
                text-align: center;
                cursor: pointer;
            }
            &.margin-bottom-20 {
                margin-bottom: 20px;
            }
            .phone-input {
                border: none;
                padding-left: 30px;
                width: 558px;
                height: 68px;
                font-size: 28px;
                color: #282e3c;
            }
        }
        > .from-submit {
            margin: 20px auto 0;
            width: 590px;
            height: 72px;
            background: rgba(6, 198, 60, 1);
            border-radius: 36px;
            font-size: 28px;
            line-height: 72px;
            font-weight: bold;
            text-align: center;
            color: #fff;
        }
    }
    .explain-box {
        margin: 20px auto;
        width: 710px;
        img {
            width: 710px;
            display: block;
        }
    }
}
</style>
